module.exports = __webpack_public_path__ + "img/HU10537914.425baaee.png";